import { nowPaymentsSlug } from '@bcraft-frontend-lib/payments'

import nowPaymentsWebp from 'modules/PaymentsPage/img/nowpayments.webp'

// slug
export const replaceIcons = {
  [nowPaymentsSlug]: nowPaymentsWebp,
}

// slug
export const replaceNames = {}
